/**
 * Provides all tokens of a specific theme edited by design team.
 * This file is automatically generated from /scripts/figma-synchronise-tokens.sh.
 * PLEASE DO NOT EDIT HERE
 */
const darkTheme = {
  colors: {
    danger: {
      background: '#482037',
      backgroundDisabled: '#301d32',
      backgroundHover: '#482037',
      backgroundStrong: '#e24b70',
      backgroundStrongDisabled: '#60233c',
      backgroundStrongHover: '#fa7995',
      backgroundWeak: '#151a2d',
      backgroundWeakDisabled: '#301d32',
      backgroundWeakHover: '#482037',
      border: '#fa7995',
      borderDisabled: '#60233c',
      borderHover: '#fa7995',
      borderStrong: '#151a2d',
      borderStrongDisabled: '#60233c',
      borderStrongHover: '#fa7995',
      borderWeak: '#e24b70',
      borderWeakDisabled: '#60233c',
      borderWeakHover: '#fa7995',
      icon: '#fa7995',
      iconDisabled: '#60233c',
      iconHover: '#fa7995',
      iconStrong: '#151a2d',
      iconStrongDisabled: '#301d32',
      iconStrongHover: '#151a2d',
      iconWeak: '#e24b70',
      iconWeakDisabled: '#60233c',
      iconWeakHover: '#fa7995',
      text: '#fa7995',
      textDisabled: '#60233c',
      textHover: '#fa7995',
      textStrong: '#151a2d',
      textStrongDisabled: '#301d32',
      textStrongHover: '#151a2d',
      textWeak: '#e24b70',
      textWeakDisabled: '#60233c',
      textWeakHover: '#fa7995'
    },
    info: {
      background: '#203355',
      backgroundDisabled: '#19233c',
      backgroundHover: '#27416d',
      backgroundStrong: '#498eea',
      backgroundStrongDisabled: '#2d5085',
      backgroundStrongHover: '#4e9bff',
      backgroundWeak: '#151a2d',
      backgroundWeakDisabled: '#19233c',
      backgroundWeakHover: '#203355',
      border: '#4e9bff',
      borderDisabled: '#2d5085',
      borderHover: '#4e9bff',
      borderStrong: '#151a2d',
      borderStrongDisabled: '#2d5085',
      borderStrongHover: '#4e9bff',
      borderWeak: '#498eea',
      borderWeakDisabled: '#2d5085',
      borderWeakHover: '#4e9bff',
      icon: '#4e9bff',
      iconDisabled: '#2d5085',
      iconHover: '#4e9bff',
      iconStrong: '#151a2d',
      iconStrongDisabled: '#19233c',
      iconStrongHover: '#151a2d',
      iconWeak: '#498eea',
      iconWeakDisabled: '#2d5085',
      iconWeakHover: '#4e9bff',
      text: '#4e9bff',
      textDisabled: '#2d5085',
      textHover: '#4e9bff',
      textStrong: '#151a2d',
      textStrongDisabled: '#19233c',
      textStrongHover: '#151a2d',
      textWeak: '#498eea',
      textWeakDisabled: '#2d5085',
      textWeakHover: '#4e9bff'
    },
    neutral: {
      background: '#23273b',
      backgroundDisabled: '#373d52',
      backgroundHover: '#23273b',
      backgroundStrong: '#373d52',
      backgroundStrongDisabled: '#373d52',
      backgroundStrongHover: '#4d5266',
      backgroundStronger: '#e0e5f0',
      backgroundStrongerDisabled: '#373d52',
      backgroundWeak: '#151a2d',
      backgroundWeakDisabled: '#373d52',
      backgroundWeakElevated: '#23273b',
      backgroundWeakHover: '#43485d',
      border: '#43485d',
      borderDisabled: '#4d5266',
      borderHover: '#43485d',
      borderStrong: '#4d5266',
      borderStrongDisabled: '#4d5266',
      borderStrongHover: '#4d5266',
      borderStronger: '#151a2d',
      borderStrongerDisabled: '#4d5266',
      borderWeak: '#4d5266',
      borderWeakDisabled: '#4d5266',
      borderWeakHover: '#4d5266',
      icon: '#e0e5f0',
      iconDisabled: '#898fa2',
      iconHover: '#e0e5f0',
      iconStrong: '#ffffff',
      iconStrongDisabled: '#898fa2',
      iconStrongHover: '#ffffff',
      iconStronger: '#151a2d',
      iconStrongerDisabled: '#898fa2',
      iconWeak: '#c2cadb',
      iconWeakDisabled: '#898fa2',
      iconWeakHover: '#e0e5f0',
      text: '#e0e5f0',
      textDisabled: '#898fa2',
      textHover: '#e0e5f0',
      textStrong: '#ffffff',
      textStrongDisabled: '#898fa2',
      textStrongHover: '#ffffff',
      textStronger: '#151a2d',
      textStrongerDisabled: '#898fa2',
      textWeak: '#c2cadb',
      textWeakDisabled: '#898fa2',
      textWeakHover: '#e0e5f0'
    },
    other: {
      data: {
        charts: {
          danger: '#e24d69',
          data1: '#7c61e7',
          data10: '#b4f2f6',
          data11: '#005899',
          data12: '#2c8666',
          data13: '#e2a1ff',
          data14: '#92ac41',
          data2: '#008df7',
          data3: '#3cb589',
          data4: '#ea8396',
          data5: '#a795ef',
          data6: '#ff602e',
          data7: '#a07f00',
          data8: '#029aa2',
          data9: '#ffa285',
          success: '#44d09e'
        }
      },
      gradients: {
        background: {
          aqua: 'linear-gradient(199.45deg, #03d5e0 14.03%, #4f0599 88.52%)',
          blue: 'linear-gradient(200.14deg, #0092ff 19.89%, #4f0599 80.37%)',
          fuschia: 'linear-gradient(200.02deg, #ff1c6e 13.34%, #4f0599 86.64%)',
          green: 'linear-gradient(202.33deg, #45d29f 15.16%, #4f0599 85.44%)',
          orange: 'linear-gradient(201.62deg, #ff5d2a 14.62%, #4f0599 85.81%)',
          pink: 'linear-gradient(200.94deg, #ff0cd2 14.71%, #4f0599 86.16%)',
          primary: 'linear-gradient(0deg, #151a2d 0%, #4f0599 100%)',
          purple: 'linear-gradient(197.81deg, #8430d9 12.89%, #4f0599 87.84%)'
        }
      },
      icon: {
        category: {
          primary: {
            fill: '#ce80ff',
            fillStrong: '#f3dffd'
          }
        },
        product: {
          danger: {
            fill: '#482037',
            fillDisabled: '#4d5266',
            fillStrong: '#482037',
            fillStrongDisabled: '#4d5266',
            fillWeak: '#e24b70',
            fillWeakDisabled: '#373d52'
          },
          primary: {
            fill: '#ce80ff',
            fillDisabled: '#4d5266',
            fillStrong: '#f3dffd',
            fillStrongDisabled: '#4d5266',
            fillWeak: '#2d2242',
            fillWeakDisabled: '#373d52'
          },
          warning: {
            fill: '#603f40',
            fillDisabled: '#4d5266',
            fillStrong: '#413038',
            fillStrongDisabled: '#4d5266',
            fillWeak: '#ff8c69',
            fillWeakDisabled: '#373d52'
          }
        }
      }
    },
    overlay: '#151A2DA6',
    primary: {
      background: '#2d2242',
      backgroundDisabled: '#23213c',
      backgroundHover: '#3e2a58',
      backgroundStrong: '#ce80ff',
      backgroundStrongDisabled: '#644184',
      backgroundStrongHover: '#e8c2ff',
      backgroundWeak: '#151a2d',
      backgroundWeakDisabled: '#23213c',
      backgroundWeakHover: '#2d2242',
      border: '#e8c2ff',
      borderDisabled: '#644184',
      borderHover: '#e8c2ff',
      borderStrong: '#151a2d',
      borderStrongDisabled: '#644184',
      borderStrongHover: '#e8c2ff',
      borderWeak: '#ce80ff',
      borderWeakDisabled: '#644184',
      borderWeakHover: '#ce80ff',
      icon: '#e8c2ff',
      iconDisabled: '#644184',
      iconHover: '#e8c2ff',
      iconStrong: '#151a2d',
      iconStrongDisabled: '#23213c',
      iconStrongHover: '#151a2d',
      iconWeak: '#ce80ff',
      iconWeakDisabled: '#644184',
      iconWeakHover: '#ce80ff',
      text: '#e8c2ff',
      textDisabled: '#644184',
      textHover: '#e8c2ff',
      textStrong: '#151a2d',
      textStrongDisabled: '#23213c',
      textStrongHover: '#151a2d',
      textWeak: '#ce80ff',
      textWeakDisabled: '#644184',
      textWeakHover: '#ce80ff'
    },
    secondary: {
      backgroundStrong: '#f3dffd'
    },
    success: {
      background: '#173e45',
      backgroundDisabled: '#162635',
      backgroundHover: '#195857',
      backgroundStrong: '#1fdaaf',
      backgroundStrongDisabled: '#1a7168',
      backgroundStrongHover: '#69eecf',
      backgroundWeak: '#151a2d',
      backgroundWeakDisabled: '#162635',
      backgroundWeakHover: '#173e45',
      border: '#69eecf',
      borderDisabled: '#1a7168',
      borderHover: '#69eecf',
      borderStrong: '#151a2d',
      borderStrongDisabled: '#1a7168',
      borderStrongHover: '#69eecf',
      borderWeak: '#1fdaaf',
      borderWeakDisabled: '#1a7168',
      borderWeakHover: '#69eecf',
      icon: '#69eecf',
      iconDisabled: '#1a7168',
      iconHover: '#69eecf',
      iconStrong: '#151a2d',
      iconStrongDisabled: '#162635',
      iconStrongHover: '#151a2d',
      iconWeak: '#1fdaaf',
      iconWeakDisabled: '#1a7168',
      iconWeakHover: '#69eecf',
      text: '#69eecf',
      textDisabled: '#1a7168',
      textHover: '#69eecf',
      textStrong: '#151a2d',
      textStrongDisabled: '#162635',
      textStrongHover: '#151a2d',
      textWeak: '#1fdaaf',
      textWeakDisabled: '#1a7168',
      textWeakHover: '#69eecf'
    },
    warning: {
      background: '#413038',
      backgroundDisabled: '#252231',
      backgroundHover: '#603f40',
      backgroundStrong: '#ff8c69',
      backgroundStrongDisabled: '#7f4e48',
      backgroundStrongHover: '#fabeab',
      backgroundWeak: '#151a2d',
      backgroundWeakDisabled: '#252231',
      backgroundWeakHover: '#413038',
      border: '#fabeab',
      borderDisabled: '#9e5d51',
      borderHover: '#fabeab',
      borderStrong: '#151a2d',
      borderStrongDisabled: '#7f4e48',
      borderStrongHover: '#fabeab',
      borderWeak: '#ff8c69',
      borderWeakDisabled: '#9e5d51',
      borderWeakHover: '#fabeab',
      icon: '#fabeab',
      iconDisabled: '#9e5d51',
      iconHover: '#fabeab',
      iconStrong: '#151a2d',
      iconStrongDisabled: '#252231',
      iconStrongHover: '#151a2d',
      iconWeak: '#ff8c69',
      iconWeakDisabled: '#9e5d51',
      iconWeakHover: '#fabeab',
      text: '#fabeab',
      textDisabled: '#9e5d51',
      textHover: '#fabeab',
      textStrong: '#151a2d',
      textStrongDisabled: '#252231',
      textStrongHover: '#151a2d',
      textWeak: '#ff8c69',
      textWeakDisabled: '#9e5d51',
      textWeakHover: '#fabeab'
    }
  },
  radii: {
    circle: '100%',
    default: '4px',
    large: '8px',
    none: '0',
    small: '2px',
    xlarge: '16px'
  },
  shadows: {
    bulk: '0px 4px 32px 8px #00000066',
    defaultShadow: '0px 0px 8px 2px #00000066',
    drawer: '0px 0px 40px 10px #0000008C',
    dropdown: '0px 4px 24px 6px #00000066',
    focusDanger: '0px 0px 0px 3px #E24B7040',
    focusInfo: '0px 0px 0px 3px rgba(73,142,234,0.25)',
    focusNeutral: '0px 0px 0px 3px #0000008C',
    focusPrimary: '0px 0px 0px 3px #CE80FF40',
    focusSuccess: '0px 0px 0px 3px rgba(31,218,175,0.25)',
    focusWarning: '0px 0px 0px 3px #FF8C6940',
    hoverDanger: '0px 4px 16px 4px #482037CC',
    hoverPrimary: '0px 4px 16px 4px #2D2242CC',
    hoverWarning: '0px 4px 16px 4px #413038CC',
    menu: '0px 0px 24px 6px #00000066',
    modal: '0px 8px 40px 10px #0000008C',
    popover: '0px 4px 32px 8px #0000008C',
    tooltip: '0px 4px 32px 8px #00000066'
  },
  space: {
    '0': '0',
    '0.25': '2px',
    '0.5': '4px',
    '1': '8px',
    '1.5': '12px',
    '10': '80px',
    '2': '16px',
    '3': '24px',
    '4': '32px',
    '5': '40px',
    '6': '48px',
    '7': '56px',
    '8': '64px',
    '9': '72px'
  },
  theme: 'dark',
  typography: {
    body: {
      fontFamily: 'Asap',
      fontSize: '16px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '24px',
      paragraphSpacing: 'none',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    bodySmall: {
      fontFamily: 'Asap',
      fontSize: '14px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '20px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    bodySmallStrong: {
      fontFamily: 'Asap',
      fontSize: '14px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '20px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    },
    bodySmallStronger: {
      fontFamily: 'Asap',
      fontSize: '14px',
      fontWeight: 'SemiBold',
      letterSpacing: '0',
      lineHeight: '20px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '600'
    },
    bodyStrong: {
      fontFamily: 'Asap',
      fontSize: '16px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '24px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    },
    bodyStronger: {
      fontFamily: 'Asap',
      fontSize: '16px',
      fontWeight: 'SemiBold',
      letterSpacing: '0',
      lineHeight: '24px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '600'
    },
    caption: {
      fontFamily: 'Asap',
      fontSize: '12px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '16px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    },
    captionSmall: {
      fontFamily: 'Asap',
      fontSize: '10px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '16px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    },
    code: {
      fontFamily: 'JetBrains',
      fontSize: '14px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '20px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    heading: {
      fontFamily: 'Asap',
      fontSize: '25px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '32px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    headingLarge: {
      fontFamily: 'Asap',
      fontSize: '35px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '48px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    headingSmall: {
      fontFamily: 'Asap',
      fontSize: '21px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '32px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    }
  }
};

export { darkTheme };
